WB.Utility = WB.Utility || {};

WB.Utility.PageVisibilityUtility = function($rootScope, $timeout) {

    var _this = this;
    this.watchers = [];

    var hiddenProperty, visibilityChangeProperty;
    if (typeof document.hidden !== 'undefined') {
        hiddenProperty = 'hidden';
        visibilityChangeProperty = 'visibilitychange';
    } else if (typeof document.mozHidden !== 'undefined') {
        hiddenProperty = 'mozHidden';
        visibilityChangeProperty = 'mozvisibilitychange';
    } else if (typeof document.msHidden !== 'undefined') {
        hiddenProperty = 'msHidden';
        visibilityChangeProperty = 'msvisibilitychange';
    } else if (typeof document.webkitHidden !== 'undefined') {
        hiddenProperty = 'webkitHidden';
        visibilityChangeProperty = 'webkitvisibilitychange';
    }

    this.isHidden = document[hiddenProperty];

    document.addEventListener(visibilityChangeProperty, visibilitychanged);

    function visibilitychanged() {
        _this.watchers.forEach(function(fn) {
            $timeout(function() {
                _this.isHidden = document[hiddenProperty];
                fn(document[hiddenProperty]);
            });
        });
    }

    this.watchPageVisibility = function(fn) {
        this.watchers.push(fn);
    };

    this.unwatchPageVisibility = function(fn) {
        var index = this.watchers.indexOf(fn);
        if (index !== -1) {
            this.watchers.slice(index, 1);
        }
    };

    /* Work Handlers for managing visibility work among state */

    this.workHandlers = [];

    this.createWorkHandler = function() {
        var handler = {};
        handler.id = this.workHandlers.length + 1;
        handler.triedOnHidden = false;
        handler.ifVisible = function(fn) {
            if (_this.isHidden) {
                handler.triedOnHidden = true;
            } else {
                fn();
            }
        };
        handler.ifNotVisible = function(fn) {
            if (_this.isHidden) {
                fn();
            }
        };
        handler.whenVisibleAgain = function(fn) {
            handler.watcher = function(isHidden) {
                if (!isHidden && handler.triedOnHidden) {
                    handler.triedOnHidden = false;
                    fn();
                }
            };
            _this.watchers.push(handler.watcher);
        };
        handler.destroy = function() {
            _this.destroyWorkHandler(handler);
        };
        this.workHandlers.push(handler);
        return handler;
    };

    this.destroyWorkHandler = function(handler) {
        if (handler.watcher) {
            this.unwatchPageVisibility(handler.watcher);
        }

        var index = this.workHandlers.indexOf(handler);
        if (index !== -1) {
            this.workHandlers.slice(index, 1);
        }
    };

};
WB.Utility.PageVisibilityUtility.$inject = ['$rootScope', '$timeout'];

WB.Core.service('PageVisibilityUtility', WB.Utility.PageVisibilityUtility);
